export default {
  name: "mob-menu",
  props: {},
  data() {
    return {
      user: JSON.parse(window.localStorage.getItem("login_data")),
      permission: localStorage.getItem("permission"),
      showReport: false,
      showGallery: false,
      showRecipients: false,
      showCreate: false,
      allowAudience: parseInt(window.localStorage.getItem("allowAudience"))
    };
  },
  methods: {
    closeAll(menu = "") {
      let val = null;
      if (menu) {
        val = this[menu];
      } else {
        this.$emit("selected");
      }
      this.showReport = false;
      this.showGallery = false;
      this.showRecipients = false;
      this.showCreate = false;
      if (menu) {
        this[menu] = val;
      }
    }
  }
};